import React, { Component } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Row
} from 'reactstrap';
import PKCEHelper from '../../../services/PKCEHelper';
import { DUENDE_CONFIG } from '../../../constants';
import DuendeTokenManager from '../../../services/DuendeTokenManager';
import './LoginSSO.css';

class LoginSSO extends Component {
  state = {
    loading: false,
    error: null
  }

  componentDidMount() {
    // Check if already authenticated with Duende
    if (DuendeTokenManager.hasValidTokens()) {
      window.location = '/astra/#/home';
    }

    // Check if user came from legacy login and wants SSO
    const legacyToken = localStorage.getItem('token');
    if (legacyToken && !DuendeTokenManager.isDuendeAuth()) {
      // User is logged in with legacy auth, show option to switch
      this.setState({ hasLegacyAuth: true });
    }
  }

  /**
   * Initiate Duende SSO login flow
   */
  handleSSOLogin = async () => {
    try {
      this.setState({ loading: true, error: null });

      // Generate PKCE parameters
      const pkceData = await PKCEHelper.generatePKCE();
      
      // Store PKCE data in sessionStorage for callback
      PKCEHelper.storePKCE(pkceData);

      // Build authorization URL
      const authUrl = new URL(`${DUENDE_CONFIG.BASE_URL}/connect/authorize`);
      authUrl.searchParams.append('client_id', DUENDE_CONFIG.CLIENT_ID);
      authUrl.searchParams.append('redirect_uri', DUENDE_CONFIG.REDIRECT_URI);
      authUrl.searchParams.append('response_type', DUENDE_CONFIG.RESPONSE_TYPE);
      authUrl.searchParams.append('scope', DUENDE_CONFIG.SCOPE);
      authUrl.searchParams.append('code_challenge', pkceData.codeChallenge);
      authUrl.searchParams.append('code_challenge_method', pkceData.codeChallengeMethod);
      authUrl.searchParams.append('state', pkceData.state);

      // Redirect to Duende authorization
      window.location.href = authUrl.toString();
    } catch (error) {
      console.error('Error initiating SSO login:', error);
      this.setState({ 
        loading: false, 
        error: 'Failed to initiate SSO login. Please try again.' 
      });
    }
  }

  handleBackToLogin = () => {
    window.location = '/astra/#/login';
  }

  render() {
    const { loading, error, hasLegacyAuth } = this.state;

    return (
      <div className="app flex-row align-items-center login-sso-container">
        <Container>
          <Row className="justify-content-center">
            <Col md="6" lg="5">
              <CardGroup>
                <Card className="p-4">
                  <CardBody className="text-center">
                    <div className="mb-4">
                      <img 
                        src="/assets/img/brand/logo-astra.png" 
                        alt="Astra Logo" 
                        style={{ maxWidth: '200px', marginBottom: '20px' }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                      <h2>Astra Green Company</h2>
                      <p className="text-muted">Single Sign-On (SSO)</p>
                    </div>

                    {error && (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    )}

                    {hasLegacyAuth && (
                      <div className="alert alert-info" role="alert">
                        <small>You are currently logged in with legacy authentication.</small>
                      </div>
                    )}

                    <div className="mb-4">
                      <p className="text-muted">
                        Sign in using your Astra corporate account
                      </p>
                    </div>

                    <Button
                      color="primary"
                      className="px-4 btn-block"
                      onClick={this.handleSSOLogin}
                      disabled={loading}
                      size="lg"
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Redirecting...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-sign-in mr-2"></i>
                          Sign In with Astra SSO
                        </>
                      )}
                    </Button>

                    <div className="mt-4">
                      <Button
                        color="link"
                        onClick={this.handleBackToLogin}
                        disabled={loading}
                      >
                        <i className="fa fa-arrow-left mr-1"></i>
                        Back to Regular Login
                      </Button>
                    </div>

                    <div className="mt-4 text-muted small">
                      <p>
                        <i className="fa fa-info-circle mr-1"></i>
                        You will be redirected to Astra Identity Server for authentication
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default LoginSSO;
